import React from "react";
import Title from "../../../components/Title/Title";
import './RegistrationPage.scss';

const Registration2027page = () => {
    return (
        <div>
            <Title>Venue and Registration</Title>
            <h5>Venue</h5>
            <p>[COMING SOON]</p>
            <h5>Registration</h5>
            <p>[COMING SOON]</p>
            <h5>Contact</h5>
            <p>If there is any question, please contact the program chairs at [COMING SOON].</p>
        </div>
    )
}

export default Registration2027page
